'use strict'

class StationSettingsPrintRundownCtrl {
    constructor ($rootScope, $http, $mdToast, $mdDialog, $state, $transitions) {
        this.$rootScope = $rootScope
        this.$http = $http
        this.$mdToast = $mdToast
        this.$mdDialog = $mdDialog
        this.$state = $state

        this.status = { saving: false, errors: false }
        this.rundownTemplates = []
        this.programs = []
        this.searchTerm = ''
        this.fetch()
        this.fetchPrograms()

        this.isSaved = false
        this.firstVisit = true

        this.$rootScope.saveDisabled = false
        this.$rootScope.saveHiden = false
        this.$rootScope.save = this.save.bind(this)

        this.unregisterStateChangeStart = $transitions.onStart({}, this.stateChangeStart.bind(this))

    }

    fetchPrograms () {
        return this.$http.get('/programs/all')
            .then(result => {
                return this.programs = result.data
            })
    }

    stateChangeStart (transition) {

        let to = transition.to()
        let toParams = transition.params()

        if (!angular.equals(this.copyRundownTemplate, this.currentRundownTemplate) && this.isSaved == false) {
            transition.abort()
            this.$mdDialog.show({
                controller: 'ConfirmDialogCtrl',
                templateUrl: 'unsavedDataDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: true
            }).then(() => {
                this.isSaved = true
                this.$state.go(to, toParams)
            })
        }
    }

    stopKeyDown (ev) {
        ev.stopPropagation()
    }

    clearSearchTerm () {
        this.searchTerm = ''
    }

    fetch () {
        this.rundownTemplates = []
        this.$http.get('print/templates_rundown').then(response => {
            this.rundownTemplates = response.data

            for (var i in this.rundownTemplates) {
                this.currentPrograms = []
                this.rundownTemplates[i].programs.map(item => {
                    this.currentPrograms.push(item.id)
                })
                this.rundownTemplates[i].programs = this.currentPrograms
            }

            if (this.$state.params.rundownTemplateId) {

                this.currentRundownTemplate = this.rundownTemplates[this.$state.params.rundownTemplateId]
                this.currentIndex = this.$state.params.rundownTemplateId
                this.copyRundownTemplate = angular.copy(this.currentRundownTemplate)
            }
        })
    }

    save () {
        return new Promise((resolve) => {
            if (this.currentRundownTemplate.id) {
                this.$http.put('/print/templates_rundown', this.currentRundownTemplate)
                    .then((response) => {
                        this.$mdToast.show({
                            templateUrl: '/partial/app.partials.toasts.object_saved?object=template', //@trans('labels.settings')
                            hideDelay: 6000,
                            position: ('top right')
                        })

                        this.fetch()

                        this.isSaved = true

                        this.rundownTemplates[this.currentIndex] = response.data

                        resolve()
                    })
            } else {
                this.$http.post('/print/templates_rundown', this.currentRundownTemplate)
                    .then((response) => {
                        this.$mdToast.show({
                            templateUrl: '/partial/app.partials.toasts.object_saved?object=template', //@trans('labels.settings')
                            hideDelay: 6000,
                            position: ('top right')
                        })

                        this.fetch()

                        this.isSaved = true

                        this.rundownTemplates[this.currentIndex] = response.data

                        resolve()
                    })
            }
        })
    }

    addRundownTemplate () {
        let indexBody = {
            title: 'template',
            body: `{#

If you want to see all requested broadcast/item data or already defined varia, you can use:

{{ dump() }}

Looking for something specific? You can set an parameter in debug function like this:

{{ dump(broadcast.title) }}
{{ dump(broadcast.blocks) }} or if you want to get the first block of an array {{ dump(broadcast.blocks|first) }}
{{ dump(broadcast.start) }}

#}
<!DOCTYPE html>
<html moznomarginboxes mozdisallowselectionprint>
<head>
    <title>{{ broadcast.title }} -  template</title>
    <link href="https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400" rel="stylesheet"/>
    <style type="text/css">

        body {
            font-family: 'Roboto', sans-serif;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            margin: 0cm;
        }

        table {
            width: 100%;
        }

        tr {
            page-break-inside:avoid;
            page-break-after:auto;
        }

        td {
            /*border: 1px solid #ff00ff;*/
            border-bottom: 5pt solid #E5E5E5;
            margin: 0;
            text-align: left;
            vertical-align: top;
        }

        td.header {
            text-align: center;
            border-bottom-width: 1pt;
            padding: .5cm 0;
        }

        td.header h1 {
            font-weight: 500;
            font-size: 16pt;
            padding: 0;
            margin: .2cm 0 .2cm 0;
        }

        td.header h2 {
            font-weight: 500;
            font-size: 14pt;
            color:rgba(0,0,0,.5);
            margin: .2cm .5cm .2cm 0;
            padding: 0;
        }

        td.type {
            width: 1.5cm;
            position: relative;
        }

        td.type > div {
            position: absolute;
            top: 0;
            width: .4cm;
            height: 100%;
        }

        td.type > svg {
            position: absolute;
            top: 0;
            left: 0.4cm;
            height: 1.2cm;
        }

        td.time {
            width:2cm;
            text-align: right;
        }

        td.time > h1,
        td.time > h2 {
            font-weight: 500;
            font-size: 14pt;
            padding: 0;
            margin: .2cm .5cm .2cm 0;
        }

        td.time > h2 {
            font-weight: 100;
        }

        td.prep .description {
            position: relative;
            top: -1px;
            margin-bottom: .3cm;
        }

        td.prep  h1 {
            font-weight: 500;
            font-size: 14pt;
            padding: 0;
            margin: .2cm .5cm .2cm 0;
        }

        td.prep  p {
            font-weight: 300;
            font-size: 12pt;
            padding: 0;
            margin: .2cm .5cm .5cm 0;
            line-height: .7cm;
        }

        td.prep .rm-size-small {
            font-size: 0.75em;
        }

        td.prep .rm-size-large {
            font-size: 1.5em;
        }

        td.prep .rm-size-huge {
            font-size: 2.5em;
        }

        /*If song */
        tr.song td {
            color:rgba(0,0,0,.4);
        }

        @page {
            margin: 0;
            size: A4;
        }

        body {
            margin: .5cm .3cm 1.5cm .3cm;
        }

    </style>
</head>
<body>
    <table border="0" cellpadding="0" cellspacing="0">
        <tr>
            <td class="header">
                <h1>{{broadcast.title}} - {{ broadcast.start|localizeddate('full', 'none')|capitalize }}</h1>
                <h2>{{broadcast.medium_name}}</h2>
            </td>
        </tr>
    </table>
    <table border="0" cellpadding="0" cellspacing="0">
        {% for block in  broadcast.blocks %}
            {% for item in  block.items %}
                <tr>
                    <td class="type">
                        <div style="background: {{item.model_type.options.color}}" ></div>
                        {% if item.model_type.options.talk %}
                            <svg class="pointer" viewBox="0 0 15 61" version="1.1" xmlns="http://www.w3.org/2000/svg" style="">
                                <polygon fill="{{item.model_type.options.color}}" transform="translate(7.500000, 30.500000) rotate(90.000000) translate(-7.500000, -30.500000) " points="7.5 23 38 38 -23 38 " />
                            </svg>
                        {% endif %}
                    </td>
                    <td class="time">
                        <h1>{{ item.start|date("H:i:s") }}</h1>
                        <h2>{{ item.duration|date("i:s") }}</h2>
                    </td>
                    <td class="prep">
                        <h1>{{ item.title }}</h1>
                        <div class="description">
                            {{ item.details|raw }} {# Do not escape the details html #}
                        </div>
                    </td>
                </tr>
            {% endfor %}
        {% endfor %}
    </table>
</body>
</html>
`,
            station: 1,
            programs: [],
        }

        if (this.isSaved == false && this.firstVisit == false) {
            event.preventDefault()
            this.$mdDialog.show({
                controller: 'ConfirmDialogCtrl',
                templateUrl: 'unsavedDataDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: true
            }).then(() => {
                let length = this.rundownTemplates.push(indexBody)

                this.openRundownTemplate(length - 1)

                this.isSaved = false
            })
        } else {
            let length = this.rundownTemplates.push(indexBody)

            this.openRundownTemplate(length - 1)

            this.isSaved = false
            this.firstVisit = false
        }
    }

    openRundownTemplate (index) {

        this.currentRundownTemplate = this.rundownTemplates[index]
        this.currentIndex = index

        this.copyRundownTemplate = angular.copy(this.currentRundownTemplate)

        this.$state.transitionTo('stationsettings.print_templates.print_rundown.rundownTemplate', { rundownTemplateId: index })

    }

    checkActiveRundownTemplate (index) {
        return this.$state.params.rundownTemplateId == index
    }

    sanitizeRundownTemplateTitle () {
        if (this.currentRundownTemplate.title) {
            this.currentRundownTemplate.title = this.currentRundownTemplate.title.trim().replace(/[^\w\d_]/gi, '').toLowerCase()
        }
    }

    preview (rundownTemplate, ev) {
        this.save().then(() => {
            this.$mdDialog.show({
                controller: 'PrintRundownCtrl',
                templateUrl: 'previewPrintDialog.ngTemplate',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: { templateId: this.rundownTemplates[this.currentIndex].id },
            })
        })
    }

    destroy (rundownTemplate, ev, index) {
        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            //parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then(() => {
            if (rundownTemplate.id) {
                this.$http.delete('/print/templates_rundown/' + rundownTemplate.id)
            }

            this.rundownTemplates.splice(index, 1)

            if (this.currentIndex === index) {
                this.$state.transitionTo('stationsettings.print_templates.print_rundown.rundownTemplate')
            }
        })
    }

    openMenu ($mdOpenMenu, ev) {
        $mdOpenMenu(ev)
    }
}

StationSettingsPrintRundownCtrl.$inject = ['$rootScope', '$http', '$mdToast', '$mdDialog', '$state', '$transitions']

module.exports = StationSettingsPrintRundownCtrl
